import * as React from 'react';
import Modal from 'react-bootstrap/Modal';

interface PhotoViewerProps {
    photos: AppFile[];
    photoIndex: number;
    showModal: boolean;
    hideModal(): void;
    update(photoIndex: number): void;
}

interface PhotoViewer {
    errors: any;
    loading: boolean;
}

interface AppFile {
    id: number;
    fileType: string;
    fileName: string;
    content: any;
}

export default class PhotoViewerModal extends React.Component<PhotoViewerProps, PhotoViewer> {
    constructor(props: PhotoViewerProps) {
        super(props);
        this.state = {
            errors: {},
            loading: false
        }
    }

    hideModal = () => {
        this.props.hideModal();
    }

    goPrev = (e: any) => {
        e.preventDefault();
        var photoIndex = this.props.photoIndex;
        var photoLength = this.props.photos.length;
        photoIndex -= 1;
        if (photoIndex < 0 || photoIndex >= photoLength) {
            //go to the last photo
            photoIndex = photoLength - 1;
        } 
        this.props.update(photoIndex);
    }

    goNext = (e: any) => {
        e.preventDefault();
        var photoIndex = this.props.photoIndex;
        var photoLength = this.props.photos.length;
        photoIndex += 1;
        if (photoIndex >= photoLength) {
            //go to the first photo
            photoIndex = 0;
        }
        this.props.update(photoIndex);
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let photo = this.props.photos[this.props.photoIndex];
        let photoNumber = this.props.photos.length;
        var url = photo != null ? "data:" + photo.fileType + ";base64," + photo.content : "";

        return (
            <div>
                <Modal show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Plan/Photos</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <a className={photoNumber === 1 ? "hidden" : "runsheet-photo--left"} href="#" onClick={(e) => this.goPrev(e)}>
                            <span className="fas fas fa-circle-left mobileMenuSize alignIconCenter"></span>
                        </a>
                        <img className="runsheet-photo--size" src={url}></img>
                        <a className={photoNumber === 1 ? "hidden" : "runsheet-photo--right"} href="#" onClick={(e) => this.goNext(e)}>
                            <span className="fas fas fa-circle-right mobileMenuSize alignIconCenter"></span>
                        </a>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}